export const build = { date:"2026-06-05.1245", stage:"alpha" }
